const features = [
  {
    icon: 'ri-refresh-line',
    title: 'Updated Finds',
    description: 'Spreadsheets refreshed regularly with the latest community-discovered products and trending items across all categories.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Real Shopping Experience',
    description: 'Every product linked has been purchased and reviewed by real Sugargoo shoppers — no bots, no fake reviews.',
  },
  {
    icon: 'ri-scales-line',
    title: 'Product Comparison',
    description: 'Side-by-side comparisons of similar items so you can pick the best quality at the best price every time.',
  },
  {
    icon: 'ri-ship-line',
    title: 'Shipping Knowledge',
    description: 'Detailed guides on Sugargoo shipping methods, cost breakdowns, and strategies to minimize your shipping fees.',
  },
  {
    icon: 'ri-hand-coin-line',
    title: 'Money Saving Tips',
    description: 'Insider tips on coupons, discount codes, warehouse consolidation, and other tricks to stretch your budget further.',
  },
];

export default function WhyChoose() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            Why Shoppers Choose Sugargoo Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Thousands of smart shoppers rely on our spreadsheets to save time, money, and avoid buying mistakes
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex flex-col items-center text-center p-5 md:p-6 bg-background-50 border border-background-200/60 rounded-xl hover:border-secondary-300 transition-colors"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}